/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAllRead.defs.js'
export { main as default } from './updateAllRead.defs.js'
